export default __webpack_public_path__ + "static/media/facebookchat.622af73a.mp3";